import React from "react";
import Checkmark from "./checkmark";

const Pricing = ({ tiers = [] }) => {
    return (
        <div className="pricing-container d-flex" id="pricing">
            {tiers.map((tier, i) => {
                const padding = i === 0 ? 'pr-20' : i === tiers.length - 1 ? 'pl-20' : 'pr-20 pl-20';
                return (
                <div key={tier._id} className={`${tier.style} d-grid ${padding}`}>
                    <div className="price-title">{tier.name}</div>
                    <p>{tier.tagline}</p>
                    <ul className="ps-0">
                        {tier.features.map((feature, i) => (
                            <li key={i}><Checkmark />{feature}</li>
                        ))}
                    </ul>
                    <h2 className="align-self-end">
                        <a href={tier.ctaUrl} target="_blank" rel="noreferrer">{tier.ctaLabel}</a>
                    </h2>
                </div>
                );
            })}
        </div>
    );
};

export default Pricing;
